import React from 'react'

const PencilSvgIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M2.5 10H3.2125L8.1 5.1125L7.3875 4.4L2.5 9.2875V10ZM1.5 11V8.875L8.1 2.2875C8.2 2.19583 8.31042 2.125 8.43125 2.075C8.55208 2.025 8.67917 2 8.8125 2C8.94583 2 9.075 2.025 9.2 2.075C9.325 2.125 9.43333 2.2 9.525 2.3L10.2125 3C10.3125 3.09167 10.3854 3.2 10.4313 3.325C10.4771 3.45 10.5 3.575 10.5 3.7C10.5 3.83333 10.4771 3.96042 10.4313 4.08125C10.3854 4.20208 10.3125 4.3125 10.2125 4.4125L3.625 11H1.5ZM7.7375 4.7625L7.3875 4.4L8.1 5.1125L7.7375 4.7625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PencilSvgIcon;
